import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import * as S from './styles';

type Props = {
  statistics?: {
    productsCount: number;
    storesCount: number;
  };
};

const CategoryInformation = ({ statistics }: Props) => {
  const { t } = useContext(AppContext);

  return (
    <S.CategoryInformation>
      {statistics &&
        t('category', 'product-list.product-and-store-count', {
          products: statistics.productsCount,
          stores: statistics.storesCount,
        })}
      <S.CategoryInformationPTag>
        {t('category', 'product-list.rank-information')}
      </S.CategoryInformationPTag>
    </S.CategoryInformation>
  );
};

export default memo(CategoryInformation);
